import ModuleLayout from "../../components/enterprise/ModuleLayout";
import { incidentTabs } from "../navigation";
import { useTranslation } from "react-i18next";

const IncidentsModulePage = ({ title, subtitle, children, dataMode = { mode: "real" } }) => {
  const { t } = useTranslation();
  return (
    <ModuleLayout title={title} subtitle={subtitle} breadcrumbs={[t("platform.nav.incidents"), title]} tabs={incidentTabs} dataMode={dataMode}>
      {children}
    </ModuleLayout>
  );
};

export default IncidentsModulePage;
